import React, { useCallback } from "react";
import { Box, Typography } from "@material-ui/core";
import { useFieldArray, useFormContext } from "react-hook-form";
import { Filter } from "components/FilterSection/Filter/Filter";
import { FilterViewModel } from "api/factories/ulits.factory";

interface FilterSectionProps {
    source: string;
    disableHeader?: boolean;
    disableBackground?: boolean;
    disableMargins?: boolean;
}

/**
 * Filter section wrapper
 * @param source autocomplete url
 * @param disableMargins disable bottom margins
 * @param disableHeader show header
 * @param disableBackground show filter background
 * @constructor
 */
export const FilterSection = ({
    source,
    disableHeader = false,
    disableBackground = false,
    disableMargins = false,
}: FilterSectionProps) => {
    const { control } = useFormContext();
    const { fields, remove, insert } = useFieldArray<FilterViewModel>({
        control,
        name: "filters",
    });

    const handleInsertFilter = useCallback(
        (index: number) => {
            insert(index, {
                name: "",
                operator: "",
                logicalOperator: "And",
            });
        },
        [insert]
    );

    return (
        <Box mb={disableMargins ? 0 : 4} flex={1}>
            {!disableHeader && (
                <Box display="flex" mr={2}>
                    <Typography component="div" variant="subtitle2">
                        <Box fontWeight="fontWeightBold">Filter rules</Box>
                    </Typography>
                </Box>
            )}

            {fields.map((filter, index) => {
                const isLastFilter = fields.length - 1 === index;
                const isOrphan = fields.length === 1;

                return (
                    <Filter
                        key={filter.id}
                        index={index}
                        item={filter}
                        source={source}
                        disableBackground={disableBackground}
                        isOrphan={isOrphan}
                        hasLogicalOperator={!isLastFilter}
                        onInsertFilter={handleInsertFilter}
                        onRemoveFilter={remove}
                    />
                );
            })}
        </Box>
    );
};
